import { db } from "../../firebase";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";
import {
  doc,
  query,
  where,
  collection,
  getDocs,
  updateDoc,
} from "firebase/firestore";

const DeleteAgent = async (agentId) => {
  /**
   * input: null
   * output: delete agent
   * description: delete agent details
   */

  try {
    let q = query(
      collection(db, "invited-agents"),
      where("aid", "==", agentId)
    );
    const agentSnapshot = await getDocs(q);

    let agent = {};
    agentSnapshot.forEach((doc) => {
      agent = { id: doc.id, ...doc.data() };
    });

    const invitedAgentCollection = doc(db, "invited-agents", agent?.id);

    const agentDocument = doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "agents",
      agentId
    );
    await updateDoc(invitedAgentCollection, {
      is_deleted: true,
    }).then(async () => {
      await updateDoc(agentDocument, {
        is_deleted: true,
      });
    });


   
  } catch (error) {
    console.log(error);
  }
};

export default DeleteAgent;
